import * as React from 'react';
export const mtbSvg = React.forwardRef(function mtbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#007952',
      d: 'M0 .097h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.38 19.372c-.926 0-1.625-.69-1.625-1.607 0-.645.154-1.045.581-1.326l2.589 2.543c-.418.29-.963.39-1.553.39h.009Zm.046-6.458c.518 0 .836.418.836 1.008 0 .654-.29 1.227-.918 1.563-.4-.39-.754-.936-.754-1.58 0-.582.318-.99.836-.99Zm2.88 1.317h.481s0-1.716 1.562-1.716h.473v7.048h-.754c-.482-.045-.881-.354-1.263-.726l-.563-.546a3.17 3.17 0 0 0 .4-.68c.127-.3.227-.864.281-1 .018-.045.046-.09.064-.127a.738.738 0 0 1 .327-.273.809.809 0 0 1 .318-.072h.072v-.409h-2.352v.409h.163c.427 0 .772.345.772.78 0 .564-.417 1.018-.417 1.018l-2.144-2.089c.963-.345 1.762-.827 1.762-1.726 0-.944-.727-1.617-2.026-1.617-1.298 0-2.207.736-2.207 1.917 0 .781.354 1.29.709 1.635-1.09.427-1.735.981-1.735 1.99 0 1.425 1.29 1.998 2.716 1.998.935 0 1.726-.282 2.343-.736 0 0 .409.636 1.58.636h4.46v-.4h-.853v-7.049h.481c1.563 0 1.563 1.717 1.563 1.717H27v-2.116h-6.685v2.116l-.01.018Z',
      fill: '#FEFEFE',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.438 12.515h.927v-.4h-2.507s-2.071 5.178-2.135 5.341c-.063-.163-2.152-5.34-2.152-5.34H5v.399h.926v7.04h-.772v.4h2.271v-.4H6.417v-6.15l2.525 6.368h.409s2.38-6.068 2.489-6.368v6.15h-.79v.4h3.17v-.4h-.79v-7.05l.008.01Z',
      fill: '#FEFEFE',
    }),
  );
});
mtbSvg.defaultProps = {
  width: '32',
  height: '33',
  viewBox: '0 0 32 33',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mtb = {
  category: 'brand',
  colorable: false,
  name: 'mtb',
  svg: mtbSvg,
};
